export const MUTATION_TYPES = {
  UPDATE_RESULT: 'UPDATE_RESULT',
  UPDATE_QUESTION_ACTIVE: 'UPDATE_QUESTION_ACTIVE',
  CLEAR_STORE: 'CLEAR_STORE',
  UPDATE_SUBMIT_LOADING: 'UPDATE_SUBMIT_LOADING',
  SET_FEEDBACK_FROM: 'SET_FEEDBACK_FROM',
  FETCH_FEEDBACK_FORM_LOADING: 'FETCH_FEEDBACK_FORM_LOADING',
  UPDATE_QUESTIONS: 'UPDATE_QUESTIONS',
};

export const ACTION_TYPES = {
  SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
  FETCH_FEEDBACK_FORM: 'FETCH_FEEDBACK_FORM',
};
